<!-- 登录页 -->
<template>
    <div :style="'height:' + innerHeight + 'px;'">
        <div class="bg"></div>
        <div class="card">
            <div class="card-left">
                <img class="card-left-img" src="@/assets/login/logo-left.png" />
                <div class="card-left-h">互联溯源 行业领先</div>
                <div class="card-left-p">
                    我们不仅是溯源系统的代名词，更是国内知名溯源系统paas服务商服务提供商技术团队拥有超过20年的软件实践与创新经验。
                </div>
                <div class="card-left-p mt200">
                    溯源追溯，都选互联溯源
                </div>
                <div class="card-left-txt">—— 专业的溯源系统服务平台</div>
            </div>
            <div class="card-right">
                <img class="title" src="@/assets/login/logo-right.png" />
                <Form
                    class="w-100"
                    ref="formInline"
                    :model="formInline"
                    :rules="ruleInline"
                >
                    <FormItem prop="account">
                        <div class="position-relative">
                            <Input
                                v-model="formInline.account"
                                type="text"
                                placeholder="请输入您的账号"
                            />
                            <Icon
                                class="form-icon"
                                size="20"
                                type="ios-person-outline"
                            ></Icon>
                        </div>
                    </FormItem>
                    <FormItem prop="pwd">
                        <div class="position-relative">
                            <Input
                                v-model="formInline.pwd"
                                type="password"
                                placeholder="请输入密码"
                            />
                            <Icon
                                class="form-icon"
                                size="20"
                                type="ios-lock-outline"
                            ></Icon>
                        </div>
                    </FormItem>
                    <div class="form-txt">忘记密码？</div>
                    <FormItem>
                        <Button
                            class="mt100"
                            @click="handleSubmit('formInline')"
                            >登录</Button
                        >
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { plat_login } from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { setCookies } from "@/utils/helper";
export default {
    data() {
        return {
            innerHeight: 0,
            formInline: {
                account: "",
                pwd: "",
            },
            ruleInline: {
                account: [
                    {
                        required: true,
                        message: "账户不能为空",
                        trigger: "blur",
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    metaInfo: {
        title: "首页",
        meta: [
            {
                name: "viewport",
                content:
                    "width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2",
            },
        ],
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
    },
    created() {
        var _this = this;
        document.onkeydown = function () {
            if (_this.$route.name === "登录") {
                let key = window.event.keyCode;
                if (key == 13) {
                    _this.handleSubmit("formInline");
                }
            }
        };
    },
    methods: {
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    plat_login(this.formInline)
                        .then((res) => {
                            this.$Message.success(res.msg);
                            setCookies("platToken", res.data.token);
                            this.$router.push({ path: "/admin" });
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                } else {
                    this.$Message.error("数据不能为空");
                }
            });
        },
    },
};
</script>

<style scoped>
.ivu-icon {
    width: 30px;
}
.bg {
    background: url("../../assets/login/logo-bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.card {
    margin: 100px;
    padding: 48px;
    position: absolute;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    width: calc(100% - 200px);
    border-radius: 10px;
}
.card-left {
    width: 50%;
}
.card-left-h {
    margin: 100px 0 48px 0;
    padding-right: 48px;
    font-weight: bold;
    font-size: 33px;
    color: #333333;
    text-align: center;
}
.card-left-p {
    padding-right: 48px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    text-align: center;
}
.card-left-txt {
    padding-right: 48px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    text-align: right;
}
.card-right {
    padding: 3vw;
    width: 50%;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.title {
    margin: 0 0 100px 0;
    width: 164px;
    height: 36px;
}
.card-left-img {
    width: 199px;
    height: 54px;
}
.mt200 {
    margin: 200px 0 0 0;
}
.position-relative {
    position: relative;
}
.form-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 12px;
    z-index: 999;
    top: 17px;
}
.form-txt {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    text-align: right;
}
.mt100 {
    margin-top: 100px;
}
.w-100 {
    width: 100%;
    max-width: 400px;
}
::v-deep .ivu-input {
    height: 55px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #dedede;
    padding: 0 0 0 36px;
    font-size: 16px;
    color: #999999;
}
::v-deep .ivu-btn {
    width: 100%;
    height: 50px;
    background: #ff761d;
    border-radius: 5px;
    font-size: 18px;
    color: #ffffff;
}
</style>